const __WEBPACK_NAMESPACE_OBJECT__ = require("react-focus-lock");